var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"loading":_vm.ChartLoading,"type":"bar","height":300,"options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }